import _ from 'lodash';

export const CINNAMON_OCR_STATUS = [
  {
    id: 1,
    label: 'Pending',
    code: 1,
  },
  {
    id: 2,
    label: 'Processing',
    code: 2,
  },
  {
    id: 3,
    label: 'In Review',
    code: 3,
  },
  {
    id: 4,
    label: 'Done',
    code: 4,
  },
  {
    id: 5,
    label: 'Editing',
    code: 8,
  },
  {
    id: 6,
    label: 'Error',
    code: 9,
  },
];
export const TW_OCR_STATUS = [
  {
    id: 1,
    label: 'OcrPending',
    code: 1,
  },
  {
    id: 2,
    label: 'OcrProcessing',
    code: 2,
  },
  {
    id: 3,
    label: 'OcrDone',
    code: 4,
  },
  {
    id: 4,
    label: 'TwDone',
    code: 5,
  },
  {
    id: 5,
    label: 'Error1',
    code: 91,
  },
  {
    id: 6,
    label: 'Error2',
    code: 92,
  },
  {
    id: 7,
    label: 'Error3',
    code: 93,
  },
  {
    id: 8,
    label: 'Error4',
    code: 94,
  },
  {
    id: 9,
    label: 'Error9',
    code: 99,
  },
];
export const AI_OCR_FLG = [
  {
    id: 1,
    label: 'Off',
    code: 0,
  },
  {
    id: 2,
    label: 'On',
    code: 1,
  },
];

const sampleDoc = {
  documentManageId: 'DOC000000007719',
  documentTrx: 4,
  tradingId: 'T202508200000001',
  tradingFlowId: '2',
  entityId: 'EIC000000011853',
  processId: 'ICREQ01',
  processSeq: 1,
  eventCancel: 0,
  registSectionId: 'SE00000716',
  documentName: 'demo_invoice_demo1.pdf',
  documentType: null,
  documentPath:
    '/files/tw/documents/EIC000000011853/DAC202509100000002/demo_invoice_demo1.pdf',
  documentSize: 195629,
  viewRange: null,
  documentArchiveId: 'DAC202509100000002',
  documentCommentText: '',
  documentLinkInv: 1,
  documentLinkPl: 0,
  documentLinkSi: 0,
  documentLinkAn: 0,
  documentLinkBl: 0,
  documentLinkCo: 0,
  documentLinkOthers1: 0,
  documentLinkOthers2: 0,
  documentLinkOthers3: 0,
  documentLinkOthers4: 0,
  documentLinkOthers5: 0,
  documentLinkLabelOthers1: '',
  documentLinkLabelOthers2: '',
  documentLinkLabelOthers3: '',
  documentLinkLabelOthers4: '',
  documentLinkLabelOthers5: '',
  deleteFlg: 0,
  updateDate: '2025-09-17T05:01:20Z',
  updateUserName: 'Importer1_forDevCS_Org1_PIC',
  updateUserIcon: '/files/tw/users/default/icon.png',
  editableFlg: 1,
};

// 全ステータス表示確認用
export const sampleDocList = [];

TW_OCR_STATUS.map(status => {
  const clone = _.cloneDeep(sampleDoc);
  clone.aiOcrStatus = status.code;
  sampleDocList.push(clone);
});

const clone_zero = _.cloneDeep(sampleDoc);
clone_zero.aiOcrStatus = 0;
sampleDocList.unshift(clone_zero)
